import { Contact } from 'Contacts/Types/types'
import {
  AddContactAction,
  UpdateContactAction,
  GetContactsAction,
  RequestContactsAction,
  CREATE_CONTACT,
  EDIT_CONTACT,
  RECEIVE_CONTACTS,
  REQUEST_CONTACTS
} from './actions'
import initialState from './initialState'

const reducer = (
  state = initialState,
  action: AddContactAction | UpdateContactAction | GetContactsAction | RequestContactsAction
) => {
  switch (action.type) {
    case REQUEST_CONTACTS:
      return Object.assign({}, state, {
        loading: action.loading
      })
    case RECEIVE_CONTACTS:
      return Object.assign({}, state, {
        contactList: action.payload.data,
        loading: action.loading
      })
    case EDIT_CONTACT:
      const updatedContactIndex = state.contactList.findIndex(
        (contact: Contact) => contact._id === action.payload.data._id
      )
      return Object.assign({}, state, {
        contactList: [
          ...state.contactList.slice(0, updatedContactIndex),
          { ...action.payload.data },
          ...state.contactList.slice(updatedContactIndex + 1)
        ],
        loading: action.loading
      })
    case CREATE_CONTACT:
      const newContactList = [...state.contactList, { ...action.payload.data }].sort((a, b) => {
        return a.firstName.localeCompare(b.firstName, 'en', { sensitivity: 'base' })
      })
      return Object.assign({}, state, {
        contactList: newContactList,
        loading: action.loading
      })
    default:
      return state
  }
}

export default reducer
